
import CatalogGridCard from "../../../common/catalog/CatalogGridCard";

export default function Workshop({ workshop }) {
	return (
		<CatalogGridCard
			to={`/workshop_detail/${workshop.id}/`}
			title={workshop.title}
			imageUrl={workshop.image_url}
			product={workshop}
			showFreeBadge
			actionLabel="مشاهده کارگاه"
		/>
	);
}
